import { render, staticRenderFns } from "./LoginCallback.vue?vue&type=template&id=fd7d0ade&scoped=true"
import script from "./LoginCallback.vue?vue&type=script&lang=js"
export * from "./LoginCallback.vue?vue&type=script&lang=js"
import style0 from "./LoginCallback.vue?vue&type=style&index=0&id=fd7d0ade&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd7d0ade",
  null
  
)

export default component.exports